module.exports = __webpack_public_path__ + "img/Good.65dfaa6b.svg";